import type { FaireProductEntity } from "../../entity_types/product";

export const p_gtxbrhnaqc: FaireProductEntity = {
  token: "p_gtxbrhnaqc",
  type: "product",
  name: "Thank You Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/e63a0361f51ef8f04b5f8cdb48571fd64b580b0c24c507b93ce08240833caa1e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/07dd9d7f8283fcf7cfc650a82b274a0aca4f626c8429128502ab36265a5e9d7b.jpeg",
    "https://cdn.faire.com/fastly/b337ae6e6caac3995f09e8a1bcf466d810187a492c74f91d6382f353cb0b50ee.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:32.662Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
